import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from "react-router";
import { PropertyHandlers } from '../state/actions';
import { useDispatch, useSelector } from 'react-redux';
import { FileZipOutlined } from "@ant-design/icons";
import { Loading } from '../../Common';
import { Button, Checkbox } from 'antd';

export default function DisclosureDocCreate({item}) {
    const dispatch = useDispatch();
    const history = useHistory();
    const [selectedIds, setSelectedIds] = useState([]);
    let unmounted = {
      value: false
    };
    const {pathname} = useLocation();
    let source = axios.CancelToken.source();
    const { getPreDoraDocumentsData, getPreDoraDocumentsLoading, getPreDoraDocumentsError } = useSelector((state) => state.PropertyReducer);
    useEffect(()=>{
        let data = {
            listType: "DISCLOSURE_DOCS"
        };
        dispatch(PropertyHandlers.getPreDoraDocumentsData({data, unmounted, source}));

        return () => {
            unmounted.value = true;
            source.cancel("Cancelling in cleanup");
        }
    }, []);

    useEffect(()=>{
        let selectArr = []
        getPreDoraDocumentsData?.map((ele)=>{
            if(ele?.defaultSelected){
                selectArr.push(ele.contractId);
            }
            else if(ele?.yearCheck){
                if(item?.propertyYearBuilt > 1977){
                    selectArr.push(ele.contractId);
                }
            }
        })
        setSelectedIds(selectArr);
    }, [getPreDoraDocumentsData]);

    const handleCheckboxChange = (checked, item) => {
        if(checked){
            setSelectedIds([...selectedIds, item.contractId])
        }
        else{
            const filteredData = selectedIds?.filter((selectedId)=>selectedId !== item?.contractId);
            setSelectedIds(filteredData);
        }
    }

    const handleSave = () => {
        const successFunc = () => {
            history.push({
                pathname,
                state: {
                    category: "SELLER",
                    categoryId: item?.propertyId
                }
            })
        }
       dispatch(PropertyHandlers.createContractDocumentFunc({data: {contractIds: selectedIds, propertyId: item?.propertyId}, successFunc})); 
    }
    return (
        <div>
            <div style={{ height: "56vh", overflowY: "auto", marginBottom: "5px" }}>
                {
                    getPreDoraDocumentsLoading ? <Loading /> : getPreDoraDocumentsError ? "" : 
                    getPreDoraDocumentsData?.map((ele)=>{
                        return <div style={{display: "flex", padding: "3px 0px", alignItems: "center", gap: "5px", color: "#b0b0b0"}}>
                            <Checkbox checked={selectedIds?.includes(ele?.contractId) ? true : false} onChange={(e) => handleCheckboxChange(e.target.checked, ele)}/>
                            <div style={{fontSize: "1.1rem"}}>{ele.name} <FileZipOutlined
                                style={{
                                fontSize: "16px",
                                cursor: "pointer",
                                marginRight: "5px",
                                }}
                            /></div>
                        </div>
                    })
                }
            </div>
            <div style={{width: "100%", display: "flex", justifyContent: "center"}}>
                <Button type='primary' disabled={selectedIds?.length === 0} onClick={handleSave}>Submit</Button>
            </div>
        </div>
    )
}
